"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-dorligo-della-valle": {
    "b54c36cf": [{
      "hkey": "b06c9bf3",
      "slug": "san-dorligo-della-valle",
      "name": "San Dorligo della Valle",
      "primary": true,
      "skipSearch": false
    }],
    "bottazzo": [{
      "hkey": "b06c9bf3",
      "slug": "san-dorligo-della-valle",
      "name": "San Dorligo della Valle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "837cc9b0": [{
      "hkey": "b06c9bf3",
      "slug": "san-dorligo-della-valle",
      "name": "San Dorligo della Valle",
      "primary": true,
      "skipSearch": false
    }],
    "francovez": [{
      "hkey": "b06c9bf3",
      "slug": "san-dorligo-della-valle",
      "name": "San Dorligo della Valle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e58ec611": [{
      "hkey": "b06c9bf3",
      "slug": "san-dorligo-della-valle",
      "name": "San Dorligo della Valle",
      "primary": true,
      "skipSearch": false
    }],
    "lacotisce": [{
      "hkey": "b06c9bf3",
      "slug": "san-dorligo-della-valle",
      "name": "San Dorligo della Valle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "977fb883": [{
      "hkey": "b06c9bf3",
      "slug": "san-dorligo-della-valle",
      "name": "San Dorligo della Valle",
      "primary": true,
      "skipSearch": false
    }],
    "log-mattonaia": [{
      "hkey": "b06c9bf3",
      "slug": "san-dorligo-della-valle",
      "name": "San Dorligo della Valle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5c9966ca": [{
      "hkey": "731b0ddc",
      "slug": "pesek",
      "name": "Pesek",
      "primary": true,
      "skipSearch": false
    }],
    "pese": [{
      "hkey": "731b0ddc",
      "slug": "pesek",
      "name": "Pesek",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "891b62ec": [{
      "hkey": "b5160ac2",
      "slug": "sant-antonio-in-bosco",
      "name": "Sant'Antonio in Bosco",
      "primary": true,
      "skipSearch": false
    }],
    "san-antonio-in-bosco": [{
      "hkey": "b5160ac2",
      "slug": "sant-antonio-in-bosco",
      "name": "Sant'Antonio in Bosco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;